module.exports = __webpack_public_path__ + "img/materix.a5d96e20.png";